import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { PaymentProfile } from 'src/app/core/interfaces/purchase.model';
import { PWCheckoutLoaderService } from 'src/app/core/services/pwcheckout.service';
import { TransactionsService } from 'src/app/core/services/transactions.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

declare var PWCheckout: any;

@Component({
  selector: 'app-payment-options-mini',
  templateUrl: './payment-options-mini.component.html',
  styleUrls: ['./payment-options-mini.component.css'],
})
export class PaymentOptionsMiniComponent implements OnInit {
  @Input() paraSusscripcion = false;
  @Output() fnSeleccionarTarjeta = new EventEmitter<any>();

  listaTarjetas: PaymentProfile[] = [];
  cargando = false;
  key = environment.siemprePagoNoCVV_publicKey;
  uniqueID: string;

  PWCheckout_Properties = {
    name: 'Ingreso de tarjeta',
    image: `${environment.hostName}/assets/img/logos_cinemateca/Logo completo negro.png`,
    email: this.auth.getEmail(),
    description: '',
    currency: 'UYU',
    lang: 'ESP',
    form_id: 'payment_form',
    checkout_card: 1,
    autoSubmit: 'false',
    email_edit: 'false',
  };

  constructor(
    private transactionsService: TransactionsService,
    private auth: AuthService,
    private _pwCheckout: PWCheckoutLoaderService,
    private _ngZone: NgZone,
  ) { }

  ngOnInit(): void {
    this.loadSiemprePagoJavascript();
    this.cargarTarjetas();
  }

  eliminarTarjeta(PaymentProfileId: number) {
    this.cargando = true;

    this.transactionsService.eliminarTarjeta(PaymentProfileId).then((resp: any) => {
      this.cargando = false;

      if (resp.uniqueId) {
        this.cargarTarjetas();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'UPS!',
          text: 'Ha ocurrido un error inesperado. Recargue el navegador e intente nuevamente',
          timer: 1500,
        });
      }
    });
  }

  cargarTarjetas() {
    this.cargando = true;

    // Obtener lista de tarjetas
    this.transactionsService.obtenerTarjetasDePago(!this.paraSusscripcion).then((resp) => {
      this.cargando = false;
      if (resp) {
        this.listaTarjetas = resp.paymentOptions;
        this.uniqueID = resp.uniqueId;
        let selected = this.listaTarjetas.find((t) => t.isDefaultSuscription);
        this.seleccionarTarjeta(selected?.paymentProfileId);
      }
    });
  }

  seleccionarTarjeta(PaymentProfileId: number) {
    this.listaTarjetas.forEach((t) => (t.selected = t.paymentProfileId === PaymentProfileId));
  }

  agregarTarjeta() {
    if (this.uniqueID) this.openIframeCustom();
    else this.openIframeNormal();
  }

  ingresarTarjeta() {
    this.openIframeNormal();
  }

  guardar() {
    let selected = this.listaTarjetas.find((t) => t.selected);
    if (!selected.isDefaultSuscription) this.fnSeleccionarTarjeta.next(selected);
  }

  //#region METODOS Siempre Pago
  loadSiemprePagoJavascript() {
    try {
      this._pwCheckout
        .loadScript(environment.siemprePago_enviroment, this.key)
        .then((data) => {
          PWCheckout.SetStyle({
            backgroundColor: 'ffffff',
            buttonColor: '2e6da4',
            buttonHoverColor: '363636',
            buttonTextColor: 'ffffff',
            buttonTextHoverColor: 'ffffff',
            inputBackgroundColor: 'ffffff',
            inputTextColor: '141426',
            inputErrorColor: 'ff0000',
            inputAddonBackgroundColor: 'ffffff',
            labelColor: '494949',
          });

          PWCheckout.SetProperties(this.PWCheckout_Properties);

          PWCheckout.Bind('tokenCreated', this.onTokenCreated.bind(this));
        })
        .catch((error) => console.log('ERROR loadJS', error));
    } catch (error) {
    }
  }

  joinErrorsMessages(errors: Error[]) {
    let errorRes: string = '';
    for (const error of errors) {
      errorRes += error.message + '\n';
    }
    return errorRes;
  }

  onTokenCreated(token) {
    this._ngZone.run(() => {
      this.cargarTarjetas();
    });
  }

  openIframeNormal() {
    PWCheckout.OpenIframeNormal();
  }

  openIframeCustom() {
    let CaptureURL = environment.siemprePago_captureURL;

    PWCheckout.OpenIframeCustom(`${CaptureURL}?key=${this.key}&session_id=${this.uniqueID}`, this.uniqueID);
  }
  //#endregion
}
